import React from 'react';
import { Check, Cancel } from 'iconoir-react';
import { STAGE_ICONS, STAGE_STATUS_STYLES, formatDateTime } from './trackingUtils';

const Stage = ({ stage, isLast, nextStatus }) => {
    const style = STAGE_STATUS_STYLES[stage.status] || STAGE_STATUS_STYLES.pending;
    const Icon = stage.status === 'completed' ? Check : stage.status === 'cancelled' ? Cancel : STAGE_ICONS[stage.code];
    const date = formatDateTime(stage.date);
    // El conector se pinta de verde solo si la etapa terminó y la siguiente ya fue alcanzada
    const connectorDone = stage.status === 'completed' && nextStatus !== 'pending';

    return (
        <li className={`relative flex md:flex-col md:items-start md:flex-1 gap-3 md:gap-2 pb-6 md:pb-0 ${stage.supported === false ? 'opacity-60' : ''}`}>
            {!isLast && (
                <span
                    aria-hidden="true"
                    className={`absolute left-5 top-10 bottom-0 w-0.5 md:left-5 md:top-5 md:bottom-auto md:h-0.5 md:w-full ${connectorDone ? 'bg-colorprimarygreen' : 'bg-colorfifth'}`}
                />
            )}
            <div className={`relative z-10 shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${style.circle}`}>
                {Icon && <Icon width={20} height={20} />}
            </div>
            <div className="text-left">
                <div className={`text-sm font-semibold ${style.label}`}>{stage.label}</div>
                <div className="text-sm text-gray-400">{date || style.text}</div>
            </div>
        </li>
    );
};

export const TrackingStepper = ({ etapas = [] }) => {
    if (etapas.length === 0) return null;

    return (
        <section className="bg-white border border-colorfifth rounded-xl p-4 md:p-6 text-left" aria-label="Progreso de la solicitud">
            <ol className="flex flex-col md:flex-row">
                {etapas.map((stage, i) => (
                    <Stage
                        key={stage.code}
                        stage={stage}
                        isLast={i === etapas.length - 1}
                        nextStatus={etapas[i + 1]?.status}
                    />
                ))}
            </ol>
        </section>
    );
};
